/* MSE_REVIEW_EXTRAS_V1_20261005 */
(() => {
  'use strict';

  const ALL_API =
    'https://traceamp.msebeauty.de/api/reviews/all';

  const MEDIA_API =
    'https://traceamp.msebeauty.de/api/reviews/media';

  const TXT = {
    de: {
      gallery: 'Fotos & Videos aus Bewertungen',
      media: 'Mit Foto/Video',
      carouselEyebrow: 'MSE Kundenstimmen',
      carouselTitle: 'Das sagen unsere Kunden',
      all: 'Alle Bewertungen',
      verified: '✓ Verifizierter Kauf',
      anonymous: 'Anonym',
      info: 'ⓘ',
      infoAria: 'Hinweis zur Bewertung',
      infoText: 'Für die Abgabe dieser Bewertung wurden 5 € als Dankeschön gewährt – unabhängig vom Inhalt oder der Sternebewertung.',
      close: 'Schließen'
    },
    en: {
      gallery: 'Photos & videos from reviews',
      media: 'With photo/video',
      carouselEyebrow: 'MSE customer feedback',
      carouselTitle: 'What our customers say',
      all: 'All reviews',
      verified: '✓ Verified purchase',
      anonymous: 'Anonymous',
      info: 'ⓘ',
      infoAria: 'Review information',
      infoText: 'A €5 thank-you was given for submitting this review, regardless of its content or star rating.',
      close: 'Close'
    },
    fr: {
      gallery: 'Photos et vidéos des avis',
      media: 'Avec photo/vidéo',
      carouselEyebrow: 'Avis clients MSE',
      carouselTitle: 'Ce que disent nos clients',
      all: 'Tous les avis',
      verified: '✓ Achat vérifié',
      anonymous: 'Anonyme',
      info: 'ⓘ',
      infoAria: 'Information sur l’avis',
      infoText: 'Un remerciement de 5 € a été accordé pour la publication de cet avis, indépendamment de son contenu ou de sa note.',
      close: 'Fermer'
    },
    vi: {
      gallery: 'Ảnh & video từ đánh giá',
      media: 'Có ảnh/video',
      carouselEyebrow: 'Đánh giá từ khách hàng MSE',
      carouselTitle: 'Khách hàng nói gì về MSE',
      all: 'Tất cả đánh giá',
      verified: '✓ Đã mua hàng xác thực',
      anonymous: 'Ẩn danh',
      info: 'ⓘ',
      infoAria: 'Thông tin về đánh giá',
      infoText: 'Khách hàng nhận 5 € như một lời cảm ơn vì đã gửi đánh giá, không phụ thuộc vào nội dung hay số sao.',
      close: 'Đóng'
    }
  };

  const lang = (value) => {
    const key = String(value || 'de')
      .toLowerCase()
      .replace('_', '-')
      .split('-')[0];
    return TXT[key] ? key : 'de';
  };

  const starText = (rating) => {
    const n = Math.max(
      0,
      Math.min(5, Math.round(Number(rating) || 0))
    );
    return '★'.repeat(n) + '☆'.repeat(5 - n);
  };

  const mediaItems = (row) => {
    const source =
      Array.isArray(row && row.media)
        ? row.media
        : [];
    return source
      .map((item) => ({
        type: String(item && item.type || ''),
        url: String(item && item.url || ''),
        position: Number(item && item.position || 0)
      }))
      .filter((item) =>
        item.url &&
        ['image', 'video', 'video_poster'].includes(item.type)
      )
      .sort((a, b) => a.position - b.position);
  };

  const productData = (row) => {
    const product =
      row && typeof row.product === 'object'
        ? row.product
        : {};
    return {
      title: String(
        row.product_title ||
        row.product_name ||
        product.title ||
        ''
      ).trim(),
      url: String(
        row.product_url ||
        product.url ||
        (
          row.product_handle
            ? '/products/' + row.product_handle
            : ''
        )
      ).trim(),
      image: String(
        row.product_image_url ||
        row.product_image ||
        product.image_url ||
        product.image ||
        ''
      ).trim()
    };
  };

  const fetchRows = async (perPage) => {
    const url = new URL(ALL_API);
    url.searchParams.set('page', '1');
    url.searchParams.set(
      'per_page',
      String(perPage || 48)
    );
    url.searchParams.set('rating', '0');
    url.searchParams.set('sort', 'newest');

    const response = await fetch(
      url.toString(),
      {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Review API HTTP ' + response.status
      );
    }

    const data = await response.json();
    return Array.isArray(data.reviews)
      ? data.reviews
      : [];
  };

  const fetchMediaRows = async (perPage) => {
    const url = new URL(MEDIA_API);

    url.searchParams.set(
      'page',
      '1'
    );

    url.searchParams.set(
      'per_page',
      String(perPage || 48)
    );

    url.searchParams.set(
      'rating',
      '0'
    );

    url.searchParams.set(
      'sort',
      'newest'
    );

    const response = await fetch(
      url.toString(),
      {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Review media API HTTP '
        + response.status
      );
    }

    const data =
      await response.json();

    return Array.isArray(
      data.reviews
    )
      ? data.reviews
      : [];
  };

  const buildLightbox = (msg) => {
    let root =
      document.querySelector(
        '[data-mse-review-lightbox]'
      );

    if (root) return root;

    root = document.createElement('div');
    root.className = 'mse-review-lightbox';
    root.dataset.mseReviewLightbox = '1';
    root.hidden = true;

    const inner = document.createElement('div');
    inner.className = 'mse-review-lightbox__inner';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'mse-review-lightbox__close';
    close.textContent = '×';
    close.setAttribute('aria-label', msg.close);

    const media = document.createElement('div');
    media.dataset.mseReviewLightboxMedia = '1';

    const hide = () => {
      const video = media.querySelector('video');
      if (video) {
        try { video.pause(); } catch (error) {}
      }
      media.replaceChildren();
      root.hidden = true;
      document.documentElement.style.overflow = '';
    };

    close.addEventListener('click', hide);
    root.addEventListener('click', (event) => {
      if (event.target === root) hide();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        hide();
      }
    });

    inner.append(close, media);
    root.appendChild(inner);
    document.body.appendChild(root);

    root.openMedia = (item) => {
      media.replaceChildren();
      let node;
      if (item.type === 'video') {
        node = document.createElement('video');
        node.controls = true;
        node.playsInline = true;
        node.autoplay = true;
        node.src = item.url;
        if (item.poster) node.poster = item.poster;
      } else {
        node = document.createElement('img');
        node.src = item.url;
        node.alt = '';
      }
      node.className = 'mse-review-lightbox__media';
      media.appendChild(node);
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };

    return root;
  };

  const installGallery = async (root) => {
    if (root.dataset.mseMediaExtras === '1') {
      return;
    }
    root.dataset.mseMediaExtras = '1';

    const locale =
      root.dataset.locale ||
      document.documentElement.lang ||
      'de-DE';
    const msg = TXT[lang(locale)];

    const head =
      root.querySelector('.mse-product-reviews__head');
    const toolbar =
      root.querySelector('.mse-all-reviews__toolbar');
    const filters =
      root.querySelector('[data-mse-all-filters]');
    const list =
      root.querySelector('[data-mse-all-list]');

    if (!filters || !list) return;

    try {
      const rows = await fetchMediaRows(48);
      const galleryItems = [];

      rows.forEach((row) => {
        if (galleryItems.length >= 12) return;

        const items = mediaItems(row);
        const poster =
          items.find((item) =>
            item.type === 'video_poster'
          );

        items.forEach((item) => {
          if (galleryItems.length >= 12) return;
          if (item.type === 'video_poster') return;
          galleryItems.push({
            type: item.type,
            url: item.url,
            poster:
              item.type === 'video' && poster
                ? poster.url
                : '',
            product: productData(row)
          });
        });
      });

      if (!galleryItems.length) return;

      const section =
        document.createElement('section');
      section.className = 'mse-review-gallery';

      const title =
        document.createElement('h2');
      title.className =
        'mse-review-gallery__title';
      title.textContent = msg.gallery;

      const grid =
        document.createElement('div');
      grid.className =
        'mse-review-gallery__grid';

      const lightbox =
        buildLightbox(msg);

      galleryItems.forEach((item) => {
        const button =
          document.createElement('button');
        button.type = 'button';
        button.className =
          'mse-review-gallery__tile';

        let preview;
        if (item.type === 'video') {
          if (item.poster) {
            preview =
              document.createElement('img');
            preview.src = item.poster;
            preview.alt =
              item.product.title || '';
          } else {
            preview =
              document.createElement('video');
            preview.src = item.url;
            preview.muted = true;
            preview.playsInline = true;
            preview.preload = 'metadata';
          }
          const play =
            document.createElement('span');
          play.className =
            'mse-review-gallery__play';
          play.textContent = '▶';
          button.append(preview, play);
        } else {
          preview =
            document.createElement('img');
          preview.src = item.url;
          preview.alt =
            item.product.title || '';
          preview.loading = 'lazy';
          button.appendChild(preview);
        }

        button.addEventListener(
          'click',
          () => lightbox.openMedia(item)
        );

        grid.appendChild(button);
      });

      section.append(title, grid);

      if (toolbar && toolbar.parentNode) {
        toolbar.parentNode.insertBefore(
          section,
          toolbar
        );
      } else if (head && head.parentNode) {
        head.parentNode.insertBefore(
          section,
          head.nextSibling
        );
      }
    } catch (error) {
      /* Gallery is optional; reviews remain usable. */
    }
  };

  const installCarousel = async (root) => {
    if (root.dataset.mseCarouselReady === '1') {
      return;
    }
    root.dataset.mseCarouselReady = '1';

    const locale =
      root.dataset.locale ||
      document.documentElement.lang ||
      'de-DE';
    const msg = TXT[lang(locale)];

    const eyebrow =
      root.querySelector(
        '[data-mse-review-carousel-eyebrow]'
      );
    const title =
      root.querySelector(
        '[data-mse-review-carousel-title]'
      );
    const all =
      root.querySelector(
        '[data-mse-review-carousel-all]'
      );
    const track =
      root.querySelector(
        '[data-mse-review-carousel-track]'
      );
    const prev =
      root.querySelector(
        '[data-mse-review-carousel-prev]'
      );
    const next =
      root.querySelector(
        '[data-mse-review-carousel-next]'
      );

    if (!track) return;

    if (eyebrow) eyebrow.textContent =
      msg.carouselEyebrow;
    if (title) title.textContent =
      msg.carouselTitle;
    if (all) all.textContent = msg.all;

    try {
      const rows = await fetchRows(24);
      const chosen = rows
        .filter((row) => {
          const body =
            String(row.body || '').trim();
          return body || mediaItems(row).length;
        })
        .slice(0, 8);

      if (!chosen.length) {
        root.hidden = true;
        return;
      }

      chosen.forEach((row) => {
        const card =
          document.createElement('article');
        card.className =
          'mse-review-carousel__card';

        const stars =
          document.createElement('div');
        stars.className =
          'mse-review-carousel__stars';
        stars.textContent =
          starText(row.rating);

        const meta =
          document.createElement('div');
        meta.className =
          'mse-review-carousel__meta';

        meta.appendChild(
          document.createTextNode(
            String(
              row.display_name ||
              msg.anonymous
            )
          )
        );

        if (row.verified_purchase === true) {
          meta.appendChild(
            document.createTextNode(
              ' · ' + msg.verified
            )
          );
        }

        let note = null;

        if (row.incentivized === true) {
          meta.appendChild(
            document.createTextNode(' · ')
          );

          const info =
            document.createElement('button');
          info.type = 'button';
          info.className =
            'mse-review-carousel__info';
          info.textContent = msg.info;
          info.setAttribute(
            'aria-label',
            msg.infoAria
          );
          info.setAttribute(
            'aria-expanded',
            'false'
          );

          note =
            document.createElement('div');
          note.className =
            'mse-review-carousel__note';
          note.textContent =
            msg.infoText;
          note.hidden = true;

          info.addEventListener(
            'click',
            () => {
              note.hidden =
                !note.hidden;
              info.setAttribute(
                'aria-expanded',
                note.hidden
                  ? 'false'
                  : 'true'
              );
            }
          );

          meta.appendChild(info);
        }

        card.append(stars, meta);
        if (note) card.appendChild(note);

        const body =
          String(row.body || '').trim();
        if (body) {
          const p =
            document.createElement('p');
          p.className =
            'mse-review-carousel__body';
          p.textContent = body;
          card.appendChild(p);
        }

        const product =
          productData(row);

        if (product.title) {
          const wrap =
            document.createElement(
              product.url ? 'a' : 'div'
            );
          wrap.className =
            'mse-review-carousel__product';
          if (product.url) {
            wrap.href = product.url;
          }
          if (product.image) {
            const image =
              document.createElement('img');
            image.src = product.image;
            image.alt = product.title;
            image.loading = 'lazy';
            wrap.appendChild(image);
          }
          const span =
            document.createElement('span');
          span.textContent =
            product.title;
          wrap.appendChild(span);
          card.appendChild(wrap);
        }

        const items = mediaItems(row);
        const image =
          items.find((item) =>
            item.type === 'image'
          );
        const video =
          items.find((item) =>
            item.type === 'video'
          );
        const poster =
          items.find((item) =>
            item.type === 'video_poster'
          );

        if (image || poster || video) {
          const thumb =
            document.createElement('img');
          thumb.className =
            'mse-review-carousel__thumb';
          thumb.loading = 'lazy';
          thumb.alt = product.title || '';
          thumb.src =
            image
              ? image.url
              : poster
                ? poster.url
                : '';
          if (thumb.src) {
            card.appendChild(thumb);
          }
        }

        track.appendChild(card);
      });

      const move = (direction) => {
        track.scrollBy({
          left:
            direction *
            Math.max(
              280,
              track.clientWidth * .78
            ),
          behavior: 'smooth'
        });
      };

      if (prev) {
        prev.addEventListener(
          'click',
          () => move(-1)
        );
      }
      if (next) {
        next.addEventListener(
          'click',
          () => move(1)
        );
      }
    } catch (error) {
      root.hidden = true;
    }
  };

  const start = () => {
    document
      .querySelectorAll(
        '[data-mse-all-reviews]'
      )
      .forEach(installGallery);

    document
      .querySelectorAll(
        '[data-mse-review-carousel]'
      )
      .forEach(installCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {once: true}
    );
  } else {
    start();
  }
})();
/* /MSE_REVIEW_EXTRAS_V1_20261005 */
